import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { MailAccountsService } from '../../comunications/_services/mail-account.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { MailsAccountDetailComponent } from '../mails-account-detail/mails-account-detail.component';
import { DialogService } from 'primeng/dynamicdialog';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-mails-account-list-mailboxes',
    templateUrl: './mails-account-list-mailboxes.component.html',
    styleUrls: ['./mails-account-list-mailboxes.component.css'],
    standalone: false
})
export class MailsAccountListMailboxesComponent implements OnInit {


    public mailsAccounts: any = [];
    public totalRecords: number = 0;
    public loading: boolean = false;
    private lastGridEvent: any = {
      first: 0,
      rows: 10
    };
    public type: string = "";

  constructor(
    private messageService: MessageService,    
    private confirmationService: ConfirmationService,                
    private topbarService: TopbarService,
    private mailAccountsService: MailAccountsService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
      this.route.paramMap.subscribe((params: ParamMap) => {      
        this.topbarService.setTitle("Buzones de correo");
      });
  }


  async loadData($event: any) {
      
      this.lastGridEvent = $event;  
      let filters:any = {
        IMAPEnabled: new Filter( FilterOperation.equals, 'imapEnabled', '', true),
        AllowMailboxViewer: new Filter( FilterOperation.equals, 'allowMailboxViewer', '', true)
      };
      let params:IParamsCollection = {
        page: { number: $event.first+1, size: $event.rows },            
        sort: ["name"],
        filter: FilterBuilder.fromObject(filters).build()
      }            
      
      if(typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];  
      let response = await firstValueFrom(this.mailAccountsService.all(params));
      this.mailsAccounts = response.data;
      this.totalRecords = response.meta['total'];
    }
    
    /// Abre el buzón en el lector integrado.
    openInGuai(id: any) {
      this.router.navigate(['/mailbox', id, encodeURIComponent('INBOX')]);
    }

    /// Abre el buzón en el webmail externo (Roundcube).
    ///
    /// Se mantiene mientras el lector integrado está en pruebas, para poder comparar las dos pantallas y tener
    /// vuelta atrás. Cuando se retire, desaparece con él el endpoint mailbox/login, que hoy manda al navegador
    /// del usuario la contraseña IMAP de la cuenta en base64.
    open(id: any) {
      window.open(this.mailAccountsService.getMailboxUrl(id), "_blank");
    }

}
